import { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import { FC } from 'react';

interface TProps {
  sx?: SxProps;
}

export const FadeDivider: FC<TProps> = ({ sx }) => (
  <Box
    sx={{
      height: '1px',
      mb: 3,
      mt: 3,
      background: theme =>
        `linear-gradient(to right, transparent, ${theme.palette.divider} 20%, ${theme.palette.divider} 80%, transparent)`,
      ...sx,
    }}
  />
);
